import { render, staticRenderFns } from "./textinput.vue?vue&type=template&id=2ea79ea3&"
import script from "./textinput.vue?vue&type=script&lang=js&"
export * from "./textinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports